if (!customElements.get("lid-product")) {
  class LidProduct extends HTMLElement {
    constructor() {
      super();

      this.handleAddRef = this.handleAdd.bind(this);
    }

    getVariant() {
      if (!this.lidVariants) return;

      const section = this.closest(".shopify-section");
      if (!section) return;

      const input = section.querySelector(
        `input:checked[data-option-title="${this.getAttribute(
          "data-option-title"
        )}"]`
      );
      if (!input) return;

      const value = input.value;

      return this.lidVariants.find(
        (item) => item.options && item.options.includes(value)
      );
    }

    handleAdd(event) {
      if(!event.detail.fromProduct) return;
      
      this.select = this.querySelector("select");
      if (!this.select || this.select.value != "true") return;
      
      const id = this.getVariant()?.id;
      if (!id) return;

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
        },
        body: JSON.stringify({
          "id": id,
          "quantity": 1,
          sections: "cart-icon-bubble",
        }),
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! Status: ${response.status}`);
          }
          return response.json();
        })
        .then((data) => {
          console.log("Added to cart:", data);
          
          const html = new DOMParser().parseFromString(data.sections['cart-icon-bubble'], 'text/html');
          const current = document.querySelector('.header__cart-count');
          const newCount = html.querySelector('.header__cart-count');
          if(current && newCount) current.innerHTML = newCount.innerHTML;

          document.dispatchEvent(
            new CustomEvent("dispatch:cart-drawer:refresh")
          );
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
        });
    }

    disconnectedCallback() {
      document.removeEventListener("on:cart:add", this.handleAddRef);
      document.removeEventListener("on:line-item:change", this.handleAddRef);
    }

    connectedCallback() {
      document.addEventListener("on:cart:add", this.handleAddRef);
      document.addEventListener("on:line-item:change", this.handleAddRef);

      this.lidVariants = JSON.parse(
        this.querySelector("[data-lid-variants]")?.textContent
      );
    }
  }

  customElements.define("lid-product", LidProduct);
}
